export default __webpack_public_path__ + "images/6b8d4b3b7e3fa468ab4791f35b8c591b.png";